
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle } from 'recompose'
import { translate } from 'react-switch-lang'

import MyController from '../../core/components/MyController'
import ViewContact from '../../views/global/ViewContact'

import SettingManager from '../../business/SettingManager'

class ContactController extends MyController {
	constructor(props) {
		super(props)
		this.state.isLoading = false
		this.bSetting = new SettingManager(this)
	}

	onGetContactUs = () => {
		return this.bSetting.getContactUs()
	}

	render() {
		return (
			<React.Fragment>
				{super.render()}
				<ViewContact
					onGetContactUs={this.onGetContactUs}
				/>
			</React.Fragment>
		)
	}
}

const enhance = compose(
	translate,
	withRouter,
	connect(
		(state, props) => ({

		}),
		(dispatch, props) => ({

		}),
	),
	lifecycle({
		componentDidMount() {
		}
	})
)


export default enhance(ContactController)